import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
} from '@angular/core';
import {
    TRANSLATION_CHANGE_SUMMARY_BTN,
    TranslationsService,
} from '@wdx/shared/utils';
import {
    IFormPendingChange,
    IFormPendingChangeSubForm,
} from './pending-changes.component.interface';

@Component({
    selector: 'wdx-ff-pending-changes',
    templateUrl: './pending-changes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PendingChangesComponent {
    @Input() pendingChanges: IFormPendingChange[] = [];
    get pendingChangesSubForm(): IFormPendingChangeSubForm {
        return this._pendingChangesSubForm;
    }
    @Input() set pendingChangesSubForm(subFormData: IFormPendingChangeSubForm) {
        this.subFormCount = subFormData
            ? Object.values(subFormData).reduce(
                  (acc, curr) => acc + (curr.index?.length ?? 1),
                  0,
              )
            : 0;
        this._pendingChangesSubForm = subFormData;
    }
    @Input() showButton!: boolean;
    @Output() wdxOnClick = new EventEmitter();

    private translationsService = inject(TranslationsService);

    readonly PENDING_TEXT = this.translationsService.getTranslationByKey(
        'STR_PENDING_CHANGE_ITEM',
    );

    readonly ICON_TRIANGLE_EXCLAMATION = 'triangle-exclamation';
    readonly PENDING_CHANGES_MAPPING: { [k: string]: string } = {
        '=0': 'STR_NO_PENDING_CHANGES',
        '=1': 'STR_PENDING_CHANGES_ACTIVE_SINGLE',
        other: 'STR_PENDING_CHANGES_ACTIVE_MULTIPLE',
    };
    readonly PENDING_CHANGES_SUB_FORM_UPDATE: { [k: string]: string } = {
        '=0': '',
        '=1': 'PENDING_CHANGES_SUB_FORM_UPDATE',
        other: 'PENDING_CHANGES_SUB_FORM_UPDATE_PLURAL',
    };
    readonly PENDING_CHANGES_SUB_FORM_ADD: { [k: string]: string } = {
        '=0': '',
        '=1': 'PENDING_CHANGES_SUB_FORM_ADD',
        other: 'PENDING_CHANGES_SUB_FORM_ADD_PLURAL',
    };
    readonly PENDING_CHANGES_SUB_FORM_DELETE: { [k: string]: string } = {
        '=0': '',
        '=1': 'PENDING_CHANGES_SUB_FORM_DELETE',
        other: 'PENDING_CHANGES_SUB_FORM_DELETE_PLURAL',
    };

    readonly CHANGE_SUMMARY_BTN = TRANSLATION_CHANGE_SUMMARY_BTN;

    subFormCount = 0;
    _pendingChangesSubForm!: IFormPendingChangeSubForm;

    onClick(): void {
        this.wdxOnClick.emit();
    }
}
